var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"close-on-content-click":false,"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-chip',_vm._g(_vm._b({attrs:{"color":_vm.active ? 'primary' : ''}},'v-chip',attrs,false),on),[_c('v-icon',{attrs:{"small":"","left":""}},[_vm._v("mdi-filter")]),_vm._v(" "+_vm._s(_vm.label)+" ")],1)]}}])},[_c('v-card',[_c('v-card-text',[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }